/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_CURRENT_DISPUTE_DISPLAY_OBJ_RECAP =
  'GET_CURRENT_DISPUTE_DISPLAY_OBJ_RECAP';
export const GET_PLAN_TYPE_DATA_RECAP = 'GET_PLAN_TYPE_DATA_RECAP';
export const GET_REBATE_PROGRAM_RECAP = 'GET_REBATE_PROGRAM_RECAP';
export const GET_REBATE_PROGRAM_NAME_RECAP = 'GET_REBATE_PROGRAM_NAME_RECAP';
export const GET_ERROR_MSG_DISPUTE_RECAP = 'GET_ERROR_MSG_DISPUTE_RECAP';
export const GET_MANUFACTURERS_LIST_RECAP = 'GET_MANUFACTURERS_LIST_RECAP';
export const GET_DISPLAY_RECAP_GRID = 'GET_DISPLAY_RECAP_GRID';
export const GET_DRUG_RECAP = 'GET_DRUG_RECAP';
export const GET_QUARTER_RECAP = 'GET_QUARTER_RECAP';
export const GET_CODE_DATA = 'GET_CODE_DATA';
export const UPDATE_RECAP_MAILOUT_DT = 'UPDATE_RECAP_MAILOUT_DT';
export const SET_LOADING_DISPUTE_RECAP = 'SET_LOADING_DISPUTE_RECAP';
export const GET_RECENTLY_CLOSED = 'GET_RECENTLY_CLOSED';
export const ACTIVITY_TABLE_DATA = 'ACTIVITY_TABLE_DATA';
export const GET_INCLUDE_ACTIVITY = 'GET_INCLUDE_ACTIVITY';
export const GET_MANUFACTURER_NAME_RECAP = 'GET_MANUFACTURER_NAME_RECAP';
export const GET_MANUFACTURER_ID_RECAP = 'GET_MANUFACTURER_ID_RECAP';
export const GET_FROM_RECAP = 'GET_FROM_RECAP';
export const GET_TO_RECAP = 'GET_TO_RECAP';
export const GET_INCLUDE_ACTIVITY_DROPDOWN = 'GET_INCLUDE_ACTIVITY_DROPDOWN';
export const SET_DISPLAY_OBJ_RECAP = 'SET_DISPLAY_OBJ_RECAP';
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE_RECAP =
  'GET_DRAMS_INVOICE_START_QUARTER_VALUE_RECAP';
export const SET_REFRESH_DATA_RECAP = 'SET_REFRESH_DATA_RECAP';
export const REFRESH_DATA_RECAP_DISPLAY = 'REFRESH_DATA_RECAP_DISPLAY';
